import React from 'react'
import PropTypes from 'prop-types'

import Fieldset from '../Fieldset/Fieldset'

const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n)

const getInstructions = ({ minSelections, maxSelections }) => {
  const isExactSelection =
    isNumeric(minSelections) &&
    isNumeric(maxSelections) &&
    minSelections === maxSelections

  let message
  if (isExactSelection) {
    message = `Please choose ${minSelections}`
  } else if (minSelections && maxSelections) {
    message = `Please choose ${minSelections} and up to ${maxSelections}`
  } else if (minSelections) {
    message = `Please choose ${minSelections} or more`
  } else if (maxSelections) {
    message = `Please choose up to ${maxSelections}`
  }
  return message
}

const ModifierFieldset = ({ label, children, rules = {}, name }) => {
  const { minSelections, pricingMode } = rules
  const isRequired = minSelections >= 1 || pricingMode === 'REPLACES_PRICE'
  const instructions = getInstructions(rules)

  return (
    <Fieldset
      label={label}
      children={children}
      required={isRequired}
      instructions={instructions}
      name={name}
    />
  )
}

export default ModifierFieldset

ModifierFieldset.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  rules: PropTypes.object.isRequired,
  name: PropTypes.string
}
